import { useLocation, Link } from "react-router-dom";
import { useEffect } from "react";
import { SeoHead } from "@/components/SeoHead";
import { Layout } from "@/components/Layout";

const NotFound = () => {
  const location = useLocation();

  useEffect(() => {
    console.error("404 Error: User attempted to access non-existent route:", location.pathname);
  }, [location.pathname]);

  return (
    <Layout>
      <SeoHead
        title="404 — Page Not Found | Semper Fi Pump Service"
        description="The page you're looking for could not be found. Return home or browse our well pump services."
        statusCode={404}
      />
      <div className="flex min-h-[60vh] items-center justify-center">
        <div className="text-center">
          <h1 className="mb-4 text-4xl font-bold">404</h1>
          <p className="mb-4 text-xl text-muted-foreground">Oops! Page not found</p>
          <Link to="/" className="text-accent underline hover:text-accent/90">
            Return to Home
          </Link>
        </div>
      </div>
    </Layout>
  );
};

export default NotFound;
